import React, { Component } from 'react';
import { get, post } from 'axios';
import Notifications, {notify} from 'react-notify-toast';
import { inject, observer } from 'mobx-react';
import InvoiceDetail from './InvoiceDetail';

@inject('userStore')
@observer
class InvoiceView extends Component {
  render(){
    const {invoice, modalBackgroundHandler} = this.props;
    return (
      <React.Fragment>
        <div className="modal-header">
            <h4 className="modal-title">#{invoice.invoice_number}: {invoice.description}</h4>
            <button type="button" className="close" onClick={modalBackgroundHandler} aria-label="Close">
              <span aria-hidden="true">×</span>
            </button>
        </div>
        <div className="modal-body">
          <InvoiceDetail invoice={invoice}/>
        </div>
        <div className="modal-footer">
            <button type="button" className="btn btn-secondary" onClick={modalBackgroundHandler}>
              Close
            </button>
        </div>
      </React.Fragment>
    );
  }
}
export default InvoiceView;



// WEBPACK FOOTER //
// ./src/components/client/InvoiceView.js